import React from 'react'
import './SignUpOption.css'

export default function VisiblePass({passwd}) {
  return (    
    <div className='visiblePass'>
      {passwd}      
    </div>
  )
}